import { render, staticRenderFns } from "./Somos1DataEntryBulkUpload.vue?vue&type=template&id=5ba29007&scoped=true"
import script from "./Somos1DataEntryBulkUpload.vue?vue&type=script&lang=js"
export * from "./Somos1DataEntryBulkUpload.vue?vue&type=script&lang=js"
import style0 from "./Somos1DataEntryBulkUpload.vue?vue&type=style&index=0&id=5ba29007&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba29007",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ba29007')) {
      api.createRecord('5ba29007', component.options)
    } else {
      api.reload('5ba29007', component.options)
    }
    module.hot.accept("./Somos1DataEntryBulkUpload.vue?vue&type=template&id=5ba29007&scoped=true", function () {
      api.rerender('5ba29007', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/Somos1DataEntryBulkUpload.vue"
export default component.exports